import { IIconsProps } from "components/Icons/icons.model";

const VendasIcon = (props: IIconsProps) => {
  return (
    <img
      id={props.id}
      src={"/icon/menu/vendas.svg"}
      alt=""
      style={{ width: props.fontSize, height: props.fontSize }}
    />
  );
};

export default VendasIcon;
